import { createRoot } from 'react-dom/client';
import ErrorBoundary from './ErrorBoundary';
import App from './App';
import BackendGate from './BackendGate';
createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <BackendGate>
      <App />
    </BackendGate>
  </ErrorBoundary>,
);
